<div *ngFor="let shop of shops" id="id{{ shop.name }}" (click)="onShopClick(shop.name)" class="shop">
  <div>
    <div *ngIf="shop.expressPicking" class="shop-express">Экспресс комплектация</div>

    <div class="shop-address">
      {{ shop.addressFormatted }}
      <div>
        {{ shop.displayName }}
      </div>
    </div>

    <div class="shop-worktime">
      <sd-shop-working-time [shop]="shop"></sd-shop-working-time>
    </div>

    <div
      *ngIf="shop.pickupDate && (shop.pickupDate | uiTodayTomorrowDate: 'd MMMM') as pickupDate; else pickupDateEmpty"
      class="shop-delivery-date"
    >
      Можно забрать
      <span [class]="pickupDate === 'сегодня' ? 'available' : 'not-available'">
        {{ pickupDate }}
      </span>
    </div>
  </div>

  <ng-template #pickupDateEmpty>
    <div class="shop-delivery-date">Дату самовывоза уточнит оператор</div>
  </ng-template>
</div>
